<svg
  class={$$props.class}
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.9998 14H21.002V4H7.00195V8M17.002 8H3.00195V18H6.00195V20.5L10.502 18H17.002V8Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
